import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { NavLink, useNavigate } from 'react-router-dom'; // Import useNavigate
import { connect } from 'react-redux';
import { groupBy } from 'lodash';
import NotificationIcon from './NotificationIcon';
import NotificationMenuDropdown from './NotificationMenuDropdown';
import GeneralNotification from './GeneralNotification';
import { Translate } from '../../../Share/components';
import { convertStringToDate } from '../../../Share/utils/dateUtil';
import useWindowSize from '../../../Share/hooks/useWindowSize';
import './style.scss';

import {
  setNotificationReadStatus,
  getNotificationList,
  searchOrder,
} from '../../actions';

function NotificationContainer({
  allNotifications = [],
  unreadNotifications = [],
  isPage = false,
  className = { iconClass: '', pageClass: '' },
  onSetNotificationReadStatus = () => {},
  GetNotifications = () => {},
  searchOrder = () => {},
  assignmentList = [],
}) {
  const { isMobileView } = useWindowSize();
  const navigate = useNavigate();

  const handleSearchOrderCallback = (status, orders, notificationId) => {
    if (status === 0 && orders && orders.length > 0) {
      const foundOrder = orders[0];
      if (foundOrder.IsTranslation === true) {
        navigate(`/translation`, {
          state: { notificationId, orderIdentifier },
        });
      } else {
        navigate(`/my-assignment`, {
          state: {
            notificationId,
            isFromDashboard: false,
            isFromDashboardRating: false,
          },
        });
      }
    }
  };

  const handleCardClick = (
    title,
    WorkAssignmentIdentifiers,
    notificationId,
    orderIdentifier = null,
  ) => {
    if (orderIdentifier) {
      const order = assignmentList.find(
        order => order.OrderIdentifier === orderIdentifier,
      );
      if (order && order?.IsTranslation === true) {
        navigate(`/translation`, {
          state: { notificationId, orderIdentifier },
        });
      } else if (order) {
        navigate(`/my-assignment`, {
          state: {
            notificationId,
            isFromDashboard: false,
            isFromDashboardRating: false,
          },
        });
      } else {
        searchOrder(
          '',
          (status, orders) =>
            handleSearchOrderCallback(status, orders, notificationId),
          null,
          orderIdentifier,
        );
      }
    }
  };
  const [visibleNotificationDropdown, setVisibleNotificationDropdown] =
    useState(false);

  const handleCheckbox = (notification, isRead) => {
    const { NotificationIdentifier } = notification;
    onSetNotificationReadStatus(NotificationIdentifier, isRead);
  };

  const clipNotification = () => {
    const clippedNotifications = allNotifications.filter(
      item => moment(item.DatetimeSent) > moment().subtract(3, 'days'),
    );
    const limitedNotifications =
      clippedNotifications.length > 30
        ? clippedNotifications.slice(0, 30)
        : clippedNotifications;
    const totalUnreadNotifications = limitedNotifications.filter(
      item => item.IsRead === false,
    ).length;
    return {
      limitedNotifications,
      totalUnreadNotifications,
    };
  };

  const groupedNotifications = () => {
    const sorted = allNotifications.sort((a, b) =>
      convertStringToDate(b.DatetimeSent).diff(a.DatetimeSent),
    );
    const grouped = groupBy(sorted, item =>
      convertStringToDate(item.DatetimeSent).format('YYYY-MM-DD'),
    );
    return Object.entries(grouped).map(([key, value]) => ({
      date: key,
      notifications: value,
    }));
  };

  const redirectToNotification = () => {
    setVisibleNotificationDropdown(false);
    navigate('/notifications'); // Use navigate instead of history.push
  };

  return (
    <>
      {!isPage && (
        <NotificationMenuDropdown
          visible={visibleNotificationDropdown}
          setVisible={setVisibleNotificationDropdown}
          className="tv-filter-list__element"
          buttonClass="tv-notification_header"
          button={
            <NotificationIcon
              count={clipNotification().totalUnreadNotifications}
              onClick={() => {}}
              ariaExpanded={visibleNotificationDropdown ? 'true' : 'false'}
              ariaControls="notification-container"
            />
          }
        >
          <div
            className="tv-notification__container"
            id="notification-container"
          >
            <div className="tv-notification__list">
              {clipNotification()
                .limitedNotifications.sort((a, b) =>
                  convertStringToDate(b.DatetimeSent).diff(a.DatetimeSent),
                )
                .map(
                  (item, index) =>
                    item.Headline !== null && (
                      <GeneralNotification
                        key={item.NotificationIdentifier}
                        index={index}
                        title={item.Headline}
                        notificationIdentifier={item.NotificationIdentifier}
                        message={item.Message}
                        date={item.DatetimeSent}
                        isNew={!item.IsRead}
                        item={item}
                        handleCardClick={handleCardClick}
                        visibleMarkAsRead={!item.IsRead || false}
                        visibleButtons={item.visibleButtons || false}
                        handleCheck={value => handleCheckbox(item, value)}
                      />
                    ),
                )}
            </div>
            {/* <NavLink to="/notifications"> */}
            <button
              onClick={() => redirectToNotification()}
              type="button"
              className="tv-notification__button"
              tabIndex={0}
            >
              {Translate({ content: 'notification.goToNotificationPage' })}
            </button>
            {/* </NavLink> */}
          </div>
        </NotificationMenuDropdown>
      )}
      {isPage && (
        <div className={`tv-notification__page ${className.pageClass}`}>
          <h2 className="tv-notification__page__title">
            {Translate({ content: 'notification.title' })}
          </h2>
          <div className="tv-notification__container-fluid  ">
            <div className="">
              {groupedNotifications().map(item => (
                <div key={item.date}>
                  <div className="tv-notification__date">{item.date}</div>
                  {item.notifications.map(
                    (notification, index) =>
                      notification.Headline !== null && (
                        <GeneralNotification
                          key={notification.NotificationIdentifier}
                          index={index}
                          title={notification.Headline}
                          notificationIdentifier={
                            notification.NotificationIdentifier
                          }
                          message={notification.Message}
                          date={notification.DatetimeSent}
                          isNew={!notification.IsRead}
                          isPage={isPage}
                          item={notification}
                          handleCardClick={handleCardClick}
                          visibleMarkAsRead={!notification.IsRead || false}
                          visibleButtons={notification.visibleButtons || false}
                          handleCheck={value =>
                            handleCheckbox(notification, value)
                          }
                        />
                      ),
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

NotificationContainer.propTypes = {
  allNotifications: PropTypes.arrayOf(
    PropTypes.shape({
      NotificationIdentifier: PropTypes.string,
      Headline: PropTypes.string,
      Message: PropTypes.string,
      DatetimeSent: PropTypes.string,
      IsRead: PropTypes.bool,
      visibleButtons: PropTypes.bool,
      OrderIdentifier: PropTypes.string,
    }),
  ),
  unreadNotifications: PropTypes.arrayOf(
    PropTypes.shape({
      NotificationIdentifier: PropTypes.string,
      Headline: PropTypes.string,
      Message: PropTypes.string,
      DatetimeSent: PropTypes.string,
      IsRead: PropTypes.bool,
      visibleButtons: PropTypes.bool,
      OrderIdentifier: PropTypes.string,
    }),
  ),
  isPage: PropTypes.bool,
  className: PropTypes.shape({
    iconClass: PropTypes.string,
    pageClass: PropTypes.string,
  }),
  onSetNotificationReadStatus: PropTypes.func,
  GetNotifications: PropTypes.func,
  searchOrder: PropTypes.func,
  assignmentList: PropTypes.arrayOf(
    PropTypes.shape({
      OrderIdentifier: PropTypes.string,
    }),
  ),
};

const mapStateToProps = (state, props) => ({
  allNotifications: state.notification.notificationList,
  unreadNotifications: state.notification.unreadNotificationList,
  assignmentList: state.workAssignment.assignmentList,
});

const mapDispatchToProps = dispatch => ({
  onSetNotificationReadStatus: (
    notificationIdentifier,
    isRead,
    successCallback = () => {},
  ) => {
    dispatch(
      setNotificationReadStatus(
        notificationIdentifier,
        isRead,
        successCallback,
      ),
    );
  },
  GetNotifications: (orderIdentifier = null) => {
    dispatch(getNotificationList(orderIdentifier));
  },
  searchOrder: (orderNumber, onComplete, input, orderIdentifier) => {
    dispatch(searchOrder(orderNumber, onComplete, input, orderIdentifier));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NotificationContainer);
